import axios2 from '../api/axios';
export const manufacturerServices = {
    createmanufacturer,
    editmanufacturer,
    getmanufacturer,
    deletemanufacturer,
    getproductname,    
    getallmanufacturer,
}

function createmanufacturer(objdata){
    return axios2.post(`/manufacturerAdd`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function editmanufacturer(objdata){
    return axios2.post(`/editmanufacturer`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

 function deletemanufacturer(id){
     return axios2.post(`/deletemanufacturer`,id,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })  
 }
 
function getmanufacturer(page,pageSize){
    return axios2.get(`/getmanufacturer?page=${page}&limit=${pageSize}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getproductname(id=0){
    return axios2.get(`/getproductname/${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getallmanufacturer(){
     return axios2.get(`/getallmanufacturer`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}